import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "carGroup"
const CarGroupIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M6 14.25C7.243 14.25 8.25 15.257 8.25 16.5H4.5V14.25zM16.5 16.5H12.75C12.75 15.257 13.757 14.25 15 14.25H16.5z" />
          <path
            fillRule="evenodd"
            d="M15.494 5.25C16.222 5.25 16.844 5.772 16.974 6.486 17.167 7.54 17.572 9.644 17.94 10.938 18.175 11.304 18.506 11.779 18.795 12.182 18.95 12.398 19.09 12.59 19.19 12.726L19.31 12.887 19.34 12.93 19.35 12.941V12.944H19.352L19.5 13.145V20.25C19.5 21.078 18.828 21.75 18 21.75H17.25C16.422 21.75 15.75 21.078 15.75 20.25H5.25C5.25 21.078 4.578 21.75 3.75 21.75H3C2.172 21.75 1.5 21.078 1.5 20.25V13.156L1.635 12.962 3.048 10.944 4.014 6.436C4.163 5.744 4.774 5.25 5.481 5.25zM3 13.629V18.75H18V13.64L17.981 13.612C17.878 13.474 17.735 13.279 17.577 13.058 17.345 12.734 17.074 12.349 16.842 12H4.14zM4.678 10.5H16.277C15.957 9.192 15.653 7.6 15.498 6.755 15.498 6.751 15.494 6.75 15.494 6.75H5.48z"
            clipRule="evenodd"
          />
          <path d="M17.862 2.25C18.958 2.25 19.887 3.037 20.089 4.102 20.304 5.238 20.635 6.867 20.94 7.937 21.174 8.303 21.506 8.78 21.795 9.182 21.95 9.398 22.09 9.59 22.19 9.726L22.31 9.887 22.34 9.93 22.35 9.941V9.944H22.352L22.5 10.145V15.75C22.5 16.578 21.828 17.25 21 17.25V10.64L20.981 10.612C20.878 10.474 20.735 10.279 20.577 10.058 20.345 9.734 20.074 9.349 19.842 9H18.75V7.5H19.275C19.022 6.465 18.781 5.255 18.615 4.381 18.545 4.013 18.225 3.75 17.862 3.75H6.947L7.014 3.436C7.163 2.744 7.774 2.25 8.481 2.25z" />
        </svg>
      }
    </span>
  )
}
export default CarGroupIcon
